import styled from 'styled-components';

export const CardWithTablesGrid = styled.div`
  display: flex;
  justify-content: center;

  .tables_carousel {
    padding: 0 50px 0 100px;
    max-width: calc(100% - 39rem);
  }
`;



// WEBPACK FOOTER //
// ./src/routes/Embed/CallForImpact/CardWithTables/components/styles.js